import type { SVGProps } from 'react';

const SvgRcs = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" data-name="rcs" viewBox="0 0 32 32" {...props}>
    <path
      fill={props.color}
      d="M13.05 13.63c-1.35 0-2.44-1.09-2.44-2.44s1.09-2.44 2.44-2.44 2.44 1.09 2.44 2.44-1.09 2.44-2.44 2.44m0-3.38a.939.939 0 1 0 0 1.88.939.939 0 1 0 0-1.88"
    />
    <path
      fill={props.color}
      d="M4 26.42h10.81l8.29 4.84c.12.07.25.1.38.1s.26-.03.37-.1c.23-.13.38-.38.38-.65v-4.2H28c1.52 0 2.75-1.23 2.75-2.75V3.38c0-1.52-1.23-2.75-2.75-2.75H4c-1.51 0-2.75 1.24-2.75 2.75v20.29c0 1.52 1.23 2.75 2.75 2.75M2.75 3.38c0-.69.56-1.25 1.25-1.25h23.99c.69 0 1.25.56 1.25 1.25v20.29c0 .69-.56 1.25-1.25 1.25h-4.52c-.41 0-.75.34-.75.75v3.64l-7.33-4.29a.7.7 0 0 0-.38-.1H4c-.69 0-1.25-.56-1.25-1.25z"
    />
    <path
      fill={props.color}
      d="M7.26 18.97h9.44v1.5H7.26zM23.91 5.63H8.02c-.41 0-.75.34-.75.75v9.89c0 .41.34.75.75.75h15.89c.41 0 .75-.34.75-.75V6.38c0-.41-.34-.75-.75-.75M8.76 7.13h14.39v5.57l-2.05-2.05a.754.754 0 0 0-1.06 0l-4.87 4.87H8.75V7.13Zm8.54 8.39 3.28-3.27 2.58 2.58v.7h-5.85Z"
    />
  </svg>
);

export default SvgRcs;
